import { unit } from './operations';
export const distanceToArea = (r) => (Math.pow(r, 2));
export const distanceToVolume = (r) => (Math.pow(r, 3));
export const celsius = (t) => unit(t + 273.15);
export const toCelsius = (t) => unit(t - 273.15);
//# sourceMappingURL=conversions.js.map